export default __webpack_public_path__ + "static/media/1PORTAFOLIO GENERAL ESTIMULOS PP CULTURA 28 abril 2025.342d0ecd.pdf";